module.exports = __webpack_public_path__ + "img/81545e0d6ed2e693434bc183e54c9622.png";